var _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdFullScreen24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    points: "1,7 0,7 0,0 7,0 7,1 1,1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    points: "24,7 23,7 23,1 17,1 17,0 24,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    points: "24,24 17,24 17,23 23,23 23,17 24,17 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    points: "7,24 0,24 0,17 1,17 1,23 7,23 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdFullScreen24);
export default __webpack_public_path__ + "static/media/cmdFullScreen24.3fba2f3b37e737305aacb74d44caed4e.svg";
export { ForwardRef as ReactComponent };